/* eslint-disable import/prefer-default-export */
import bugsnag from '@bugsnag/js';

/**
 * Sets up BugSnag
 */
const bugsnagClient = bugsnag('11f216642ec2529703b62a3c89493f58');

export default bugsnagClient;
